export function getTimeIdentifier() {
  return localStorage.getItem('timeIdentifier');
}

export function getZoneOffsettedDate(date) {
  const createdDate = new Date(date);
  const timeIdentifier = localStorage.getItem('timeIdentifier');

  return Intl.DateTimeFormat('en-US', {
    timeZone: timeIdentifier,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(createdDate);
}

export function formatDate(date) {
  if (!date || date === '0000-00-00 00:00:00') {
    return '';
  }

  const timeIdentifier = localStorage.getItem('timeIdentifier');

  return Intl.DateTimeFormat('en-US', {
    timeZone: timeIdentifier,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(new Date(date));
}

export function formatDateTime(date, withOffset = false) {
  if (!date || date === '0000-00-00 00:00:00') {
    return '';
  }

  const timeIdentifier = localStorage.getItem('timeIdentifier');

  const dateObj = new Date(date);
  const formattedDate = Intl.DateTimeFormat('en-US', {
    timeZone: timeIdentifier,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(dateObj);

  if (!withOffset) return formattedDate;

  const timezoneName = Intl.DateTimeFormat('en-US', {
    timeZone: timeIdentifier,
    timeZoneName: 'long',
  })
    .format(dateObj)
    .split(' ')
    .slice(1)
    .join(' ');

  const gmtOffset = Intl.DateTimeFormat('en-US', {
    timeZone: timeIdentifier,
    timeZoneName: 'longOffset',
  })
    .format(dateObj)
    .split(' ')[1];

  return `${formattedDate} (${gmtOffset}) ${timezoneName}`;
}
